import './TableNoContet.css'

export default function TableNoContet() {
   return (
      <div className='TableNoContet-container'>
         <p className='TableNoContet--text'>Lo siento, no hemos encontrado resultados</p>
      </div>
   )
}
